import React from "react"
import Expansion from "components/ExpansionComponent"

const InnerExpansion = ({ open, header, defaultOpen, children, rightSection, onChange }) => {


  const [innerExpanded, setInnerExpanded] = React.useState(defaultOpen);
  const handleInnerExpandedPanel = (panel) => {
    setInnerExpanded(!innerExpanded);
    if (typeof onChange === "function") {
      onChange(!innerExpanded, header)
    }
  };
  return (<Expansion
    expanded={open}
    handleExpandedPanel={handleInnerExpandedPanel}
    header={header}
    rightSection={rightSection}
  >
    {
      children
    }

  </Expansion>)
}

export default InnerExpansion